import React, { useState, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import { v4 as uuid } from "uuid";
import Input from "@material-ui/core/Input";
import Button2 from "@material-ui/core/Button";
import { useFormik } from "formik";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import * as Yup from "yup";
import axios from "axios";
import Preview from "../components/Preview.js";
import ReactSelect from "../../UI/ReactSelect";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import { BiCopy } from "react-icons/bi";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const initialValues = {
  partnerId: "",
  discountPercent: "",
  expireDate: "",
  startDate: "",
  filePath: "",
  campaignCategoryId: "",
  nameAz: "",
  descriptionAz: "",
  nameEn: "",
  descriptionEn: "",
  nameRu: "",
  descriptionRu: "",
  specialOffer: "",
  link:""
};

export default function Create(props) {
  const {
    show,
    onHide,
    onCampaigns,
    skip,
    take,
    sortField,
    orderBy,
    partners,
    campaignCategories,
  } = props;
  const [imageSrc, setImageSrc] = useState("");
  const [preview, setPreview] = useState(false);
  const [file, setFile] = useState("");
  const [isError, setIsError] = useState("");

  const form = useRef(null);
  const CreateSchema = Yup.object().shape({
    // name: Yup.string().required("Name is required"),
    partnerId: Yup.string().required("Partner is required"),
    discountPercent: Yup.string().required("Discount percent is required"),
    // link: Yup.string().required("Link is required"),
    expireDate: Yup.string().required("Expire date is required"),
    startDate: Yup.string().required("Start date is required"),
    campaignCategoryId: Yup.string().required("Campaign category is required"),
    nameAz: Yup.string().required("Name is required"),
    descriptionAz: Yup.string().required("Description is required"),
    nameEn: Yup.string().required("Name is required"),
    descriptionEn: Yup.string().required("Description is required"),
    nameRu: Yup.string().required("Name is required"),
    descriptionRu: Yup.string().required("Description is required"),
    // filePath: Yup.string().required("File is required"),
  });

  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true;
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false;
    }

    return false;
  };

  const formik = useFormik({
    initialValues,
    validationSchema: CreateSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPostCampaign(values, resetForm, setSubmitting);
    },
  });

  const [partnersOption, setPartnersOption] = React.useState({});
  function handleChangePartners(value) {
    setPartnersOption(value);
    formik.setFieldValue("partnerId", value.value);
  }

  const handleCopyName = (name) => {
    const nameAz = formik.values.nameAz;
    formik.setFieldValue(name, nameAz);
  };

  const handleCopyDescription = (description) => {
    const descriptionAz = formik.values.descriptionAz;
    formik.setFieldValue(description, descriptionAz);
  };

  const [
    campaignCategoriesOption,
    setCampaignCategoriesOption,
  ] = React.useState({});

  function handleChangeCampaignCategories(value) {
    setCampaignCategoriesOption(value);
    formik.setFieldValue("campaignCategoryId", value.value);
  }
  const imagePreview = (e) => {
    let reader = new FileReader();
    let file = e.target.files[0];
    setFile(e.target.value);

    reader.onloadend = () => {
      setImageSrc(reader.result);
    };

    reader.readAsDataURL(file);

    setPreview(true);
  };
  const onClick = (e) => {
    setPreview(false);
    setImageSrc("");
    setFile("");
  };

  const onPostCampaign = (values, resetForm, setSubmitting) => {
    const campaign = new FormData(form.current);
    campaign.append("partnerId", values.partnerId);
    campaign.append("campaignCategoryId", values.campaignCategoryId);
    campaign.append("specialOffer", values.specialOffer);


    axios
      .post(`${process.env.REACT_APP_API_URL}campaign`, campaign, {
        headers: {
          "x-requestid": uuid(),
        },
      })
      .then((res) => {
        onCampaigns(skip, take, sortField, orderBy);
        setPreview(false);
        setImageSrc("");
        setFile("");
        setSubmitting(false);
        resetForm();
        onHide();
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          setIsError(message);
        }
      );
  };

  const partnersOptions = partners.map((suggestion) => ({
    value: suggestion.id,
    label: suggestion.name,
  }));

  const campaignCategoriesOptions = campaignCategories.map((suggestion) => ({
    value: suggestion.id,
    label: suggestion.nameAz,
  }));

  useEffect(() => {
    setIsError("");
    if (!show) {
      setCampaignCategoriesOption("");
      setPartnersOption("");
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      aria-labelledby="edit"
      centered
      className="modal-right pr-0"
    >
      <form onSubmit={formik.handleSubmit} ref={form}>
        <Modal.Header closeButton>
          <Modal.Title id="edit">Create</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <ReactSelect
                    suggestions={partnersOptions}
                    handleChangeSingle={handleChangePartners}
                    single={partnersOption}
                    label="Choose partner"
                    placeholder="Choose partner"
                    inputId="partnerId"
                    error={getInputClasses("partnerId")}
                    {...formik.getFieldProps("partnerId")}
                  />
                </div>
                {formik.touched.partnerId && formik.errors.partnerId ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.partnerId}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="nameAz"
                    name="nameAz"
                    label="Name Az"
                    placeholder="Name Az"
                    className="w-100"
                    error={getInputClasses("nameAz")}
                    {...formik.getFieldProps("nameAz")}
                  />
                </div>
                {formik.touched.nameAz && formik.errors.nameAz ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.nameAz}</div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="nameEn"
                    name="nameEn"
                    label="Name En"
                    placeholder="Name En"
                    className="w-100"
                    title="Copy from Name az"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          style={{ cursor: "pointer" }}
                        >
                          <BiCopy
                            onClick={() => handleCopyName("nameEn")}
                            style={{
                              width: "17px",
                              height: "17px",
                              color: "grey",
                            }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    error={getInputClasses("nameEn")}
                    {...formik.getFieldProps("nameEn")}
                  />
                </div>
                {formik.touched.nameEn && formik.errors.nameEn ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.nameEn}</div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="nameRu"
                    name="nameRu"
                    label="Name Ru"
                    placeholder="Name Ru"
                    className="w-100"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          style={{ cursor: "pointer" }}
                          title="Copy from Name az"
                        >
                          <BiCopy
                            onClick={() => handleCopyName("nameRu")}
                            style={{
                              width: "17px",
                              height: "17px",
                              color: "grey",
                            }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    error={getInputClasses("nameRu")}
                    {...formik.getFieldProps("nameRu")}
                  />
                </div>
                {formik.touched.nameRu && formik.errors.nameRu ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.nameRu}</div>
                  </div>
                ) : null}
              </div>{" "}
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="descriptionAz"
                    name="descriptionAz"
                    label="Description Az"
                    placeholder="Description Az"
                    className="w-100"
                    error={getInputClasses("descriptionAz")}
                    {...formik.getFieldProps("descriptionAz")}
                    variant="outlined"
                    multiline
                    rowsMax="4"
                    margin="normal"
                  />
                </div>
                {formik.touched.descriptionAz && formik.errors.descriptionAz ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.descriptionAz}
                    </div>
                  </div>
                ) : null}
              </div>{" "}
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="descriptionEn"
                    name="descriptionEn"
                    label="Description En"
                    placeholder="Description En"
                    className="w-100"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          style={{ cursor: "pointer" }}
                          title="Copy from Description az"
                        >
                          <BiCopy
                            onClick={() =>
                              handleCopyDescription("descriptionEn")
                            }
                            style={{
                              width: "17px",
                              height: "17px",
                              color: "grey",
                            }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    error={getInputClasses("descriptionEn")}
                    {...formik.getFieldProps("descriptionEn")}
                    variant="outlined"
                    multiline
                    rowsMax="4"
                    margin="normal"
                  />
                </div>
                {formik.touched.descriptionEn && formik.errors.descriptionEn ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.descriptionEn}
                    </div>
                  </div>
                ) : null}
              </div>{" "}
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="descriptionRu"
                    name="descriptionRu"
                    label="Description Ru"
                    placeholder="Description Ru"
                    className="w-100"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          style={{ cursor: "pointer" }}
                          title="Copy from Description az"
                        >
                          <BiCopy
                            onClick={() =>
                              handleCopyDescription("descriptionRu")
                            }
                            style={{
                              width: "17px",
                              height: "17px",
                              color: "grey",
                            }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    error={getInputClasses("descriptionRu")}
                    {...formik.getFieldProps("descriptionRu")}
                    variant="outlined"
                    multiline
                    rowsMax="4"
                    margin="normal"
                  />
                </div>
                {formik.touched.descriptionRu && formik.errors.descriptionRu ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.descriptionRu}
                    </div>
                  </div>
                ) : null}
              </div>


              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="link"
                    name="link"
                    label="Link"
                    placeholder="Link"
                    className="w-100"
                    error={getInputClasses("link")}
                    {...formik.getFieldProps("link")}
                  />
                </div>
                {/* {formik.touched.link &&
                  formik.errors.link ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.link}
                    </div>
                  </div>
                ) : null} */}
              </div>



              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="discountPercent"
                    name="discountPercent"
                    label="Discount percent"
                    placeholder="Discount percent"
                    className="w-100"
                    error={getInputClasses("discountPercent")}
                    {...formik.getFieldProps("discountPercent")}
                  />
                </div>
                {formik.touched.discountPercent &&
                  formik.errors.discountPercent ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.discountPercent}
                    </div>
                  </div>
                ) : null}
              </div>


              <div className="col-12 col-md-12 col-lg-12 mt-3">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  {/* <ReactSelect
                    suggestions={displayTypesNames}
                    handleChangeSingle={(value) => handleChangeDisplayTypesNames(value)}
                    single={chooseDisplayTypesNames}
                    label={language(379)}
                    placeholder={language(379)}
                    inputId="ediconvert"
                  /> */}



                  <FormControlLabel
                    control={
                      <Checkbox
                        id="specialOffer"
                        name="specialOffer"
                        {...formik.getFieldProps("specialOffer")}
                      />
                    }
                    label="Special offer"
                  />


                </div>
                {formik.touched.specialOffer && formik.errors.specialOffer ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.specialOffer}
                    </div>
                  </div>
                ) : null}
              </div>



              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <InputLabel htmlFor="expiredDate">Start date</InputLabel>

                  <TextField
                    id="startDate"
                    name="startDate"
                    className="w-100"
                    type="datetime-local"
                    error={getInputClasses("startDate")}
                    {...formik.getFieldProps("startDate")}
                  />
                </div>
                {formik.touched.startDate && formik.errors.startDate ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.startDate}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <InputLabel htmlFor="expiredDate">Expire date</InputLabel>
                  <TextField
                    id="expireDate"
                    name="expireDate"
                    className="w-100"
                    type="datetime-local"
                    error={getInputClasses("expireDate")}
                    {...formik.getFieldProps("expireDate")}
                  />
                </div>
                {formik.touched.expireDate && formik.errors.expireDate ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.expireDate}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3">
                  <label htmlFor="contained-button-file">
                    <Input
                      accept="image/*"
                      id="contained-button-file"
                      type="file"
                      name="file"
                      label="File {Path}"
                      placeholder="File Path"
                      className="w-100"
                      onChange={imagePreview}
                      value={file}
                      hidden
                    />
                    <Button2 variant="contained" component="span">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Devices/Camera.svg"
                        )}
                        className="mr-2"
                      />
                      Upload image
                    </Button2>
                  </label>
                  <Preview
                    preview={preview}
                    imageSrc={imageSrc}
                    onClick={onClick}
                  />
                </div>
                {formik.touched.filePath && formik.errors.filePath ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.filePath}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <ReactSelect
                    suggestions={campaignCategoriesOptions}
                    handleChangeSingle={handleChangeCampaignCategories}
                    single={campaignCategoriesOption}
                    label="Choose category"
                    placeholder="Choose category"
                    inputId="campaignCategoryId"
                    error={getInputClasses("campaignCategoryId")}
                    {...formik.getFieldProps("campaignCategoryId")}
                  />
                </div>
                {formik.touched.campaignCategoryId &&
                  formik.errors.campaignCategoryId ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.campaignCategoryId}
                    </div>
                  </div>
                ) : null}

                {isError && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                      {isError}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => onHide(false)}>
            Close
          </Button>
          <Button type="submit">Create</Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
